/* Add needed html for custom form <select> */
/********************************************************/
$('select').not('[data-role="multiselect"]').wrap(function () {
    if ($(this).hasClass('input-sm')) {
        return '<div class="select small"></div>';
    } else {
        return '<div class="select"></div>';
    }
});